import React from 'react';
import { Alert } from '@mui/material';

import { getErrorStatus } from '../../utils/jobAccessError';

interface IDashboardErrorProps {
  error: unknown;
  fallback?: string;
}

const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error && typeof error === 'object' && 'data' in error) {
    const { data } = error as { data?: unknown };
    if (typeof data === 'string' && data.trim()) return data;
    if (data && typeof data === 'object' && 'error' in data) {
      const message = (data as { error?: unknown }).error;
      if (typeof message === 'string' && message.trim()) return message;
    }
  }

  const status = getErrorStatus(error);
  return status ? `${fallback} (HTTP ${status})` : fallback;
};

export const DashboardError = ({
  error,
  fallback = 'We could not load this information. Please try again.',
}: IDashboardErrorProps) => {
  if (!error) return null;
  return <Alert severity="error">{getErrorMessage(error, fallback)}</Alert>;
};

export default DashboardError;
